import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchAmIAdmin } from '../api/adminUsers';

/**
 * TanStack Query wrapper around `fetchAmIAdmin()` — whether the current caller
 * is a vendor-portal admin. Drives show/hide of the admin section. Admin status
 * is per-session, so we treat it as effectively immutable (infinite staleTime,
 * no background refetch), mirroring `useIdentity`.
 */
export function useIsAdmin(): UseQueryResult<{ is_admin: boolean }> {
    return useQuery({
        queryKey: ['am-i-admin'],
        queryFn: fetchAmIAdmin,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        retry: false,
    });
}
